import firebase from 'firebase/app';
import 'firebase/messaging';

/**
 * Push в личном кабинете.
 *
 * Раньше здесь стоял проект `co-selfcheckin`, а бэкенд шлёт через
 * `hkeeper-c0645`: токены из чужого проекта недоставимы в принципе.
 * Работало это только потому, что заказы рассылались FCM-топиком, на
 * который кабинет был подписан. Когда рассылку сделали точечной, по
 * конкретным сотрудникам, кабинет замолчал — устройства у него в
 * системе не было и нет.
 *
 * Ключи здесь не секрет: они всё равно уезжают в браузер. Значения
 * те же, что в приложении сотрудника (housekeeping-app,
 * lib/firebase_options.dart) — проект общий.
 */
const app = firebase.initializeApp({
  apiKey: 'AIzaSyCbE89fXMUXzNh85KJubhG1cDH9KiqZnMQ',
  authDomain: 'hkeeper-c0645.firebaseapp.com',
  projectId: 'hkeeper-c0645',
  storageBucket: 'hkeeper-c0645.firebasestorage.app',
  messagingSenderId: '944543897699',
  appId: '1:944543897699:web:753e4a18c7e6b8259e8056',
});

/**
 * Ключ web-push. Без него `getToken()` в браузере токен не выдаёт
 * вообще — молча возвращает пустую строку.
 */
export const VAPID_KEY =
  'BKemDq698W4G1y5MN51u26zOx5erMdCq-D0R5mUTsG64SXiJvPV0p8qRqDyxfSAEJctsm574HX0o8x9deFnduNA';

const isSupported = firebase.messaging.isSupported();

// Объявляем через const с готовым значением: при `let messaging;`
// TypeScript не может вывести тип и ругается на implicit any в тех,
// кто этот модуль импортирует.
const messaging = isSupported ? app.messaging() : null;

export { messaging, isSupported };
